// extracted by mini-css-extract-plugin
export default {"pageBody":"styles_pageBody__vzJBa","pageContent":"styles_pageContent__ET-Jg","back":"styles_back__mgT7m"};